(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ea-featured-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-qty-action]');
    if (!button) return;

    const form = button.closest('[data-product-card-form]');
    const input = form && form.querySelector('input[name="quantity"]');
    if (!input) return;

    const value = Math.max(1, Number.parseInt(input.value, 10) || 1);
    input.value = button.dataset.qtyAction === 'plus' ? value + 1 : Math.max(1, value - 1);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-card-form]');
    if (!form) return;

    event.preventDefault();
    const button = form.querySelector('.ea-product-card__cart');
    const status = form.querySelector('.ea-product-card__status');
    const goCart = form.querySelector('.ea-product-card__go-cart');
    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Ekleniyor';
    status.textContent = '';
    if (goCart) goCart.hidden = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });

      if (!response.ok) throw new Error('cart');

      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      document.querySelectorAll('.site-header__cart-badge').forEach((badge) => {
        badge.textContent = cart.item_count;
        badge.classList.toggle('site-header__badge--gold', cart.item_count === 0);
      });

      button.textContent = 'Eklendi';
      status.textContent = 'Sepete eklendi';
      if (goCart) goCart.hidden = false;
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1400);
    } catch (error) {
      button.textContent = originalText;
      button.disabled = false;
      status.textContent = 'Sepete eklenemedi';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
